"use client";

import { c as _c } from "react/compiler-runtime";
import { Slider, SliderTrack, SliderRange, SliderThumb } from "@radix-ui/react-slider";
interface YearRangeSliderProps {
  value: [number, number];
  min: number;
  max: number;
  step?: number;
  onChange: (value: [number, number]) => void;
  onFinalChange: (value: [number, number]) => void;
}
export default function YearRangeSlider(t0) {
  const $ = _c(14);
  const {
    value,
    min,
    max,
    step: t1,
    onChange,
    onFinalChange
  } = t0;
  const step = t1 === undefined ? 1 : t1;
  let t2;
  if ($[0] !== onChange) {
    t2 = val => onChange([val[0], val[1]]);
    $[0] = onChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onFinalChange) {
    t3 = val_0 => onFinalChange([val_0[0], val_0[1]]);
    $[2] = onFinalChange;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SliderTrack className="relative bg-gray-300 rounded-full h-1 w-full"><SliderRange className="absolute bg-[var(--primary)] h-1 rounded-full" /></SliderTrack>;
    t5 = <SliderThumb className="block w-4 h-4 bg-[var(--primary)] rounded-full" />;
    t6 = <SliderThumb className="block w-4 h-4 bg-[var(--primary)] rounded-full" />;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== max || $[8] !== min || $[9] !== step || $[10] !== t2 || $[11] !== t3 || $[12] !== value) {
    t7 = <Slider className="relative flex items-center select-none touch-none w-full h-5" value={value} min={min} max={max} step={step} onValueChange={t2} onValueCommit={t3}>{t4}{t5}{t6}</Slider>;
    $[7] = max;
    $[8] = min;
    $[9] = step;
    $[10] = t2;
    $[11] = t3;
    $[12] = value;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}